/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerAccessRevokeIn } from '../models/CustomerAccessRevokeIn';
import type { FeatureFlagAdminOut } from '../models/FeatureFlagAdminOut';
import type { FeatureFlagUpdateIn } from '../models/FeatureFlagUpdateIn';
import type { ProducerCredentialCreate } from '../models/ProducerCredentialCreate';
import type { ProducerCredentialSecretOut } from '../models/ProducerCredentialSecretOut';
import type { ProducerPrincipalCreate } from '../models/ProducerPrincipalCreate';
import type { ProducerPrincipalOut } from '../models/ProducerPrincipalOut';
import type { ScopeDefinitionIn } from '../models/ScopeDefinitionIn';
import type { ScopeDefinitionOut } from '../models/ScopeDefinitionOut';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminService {
    /**
     * Revoke Customer Access Globally
     * @returns void
     * @throws ApiError
     */
    public static revokeCustomerAccessGloballyAdminCustomerAccessRevokePost({
        requestBody,
    }: {
        requestBody: CustomerAccessRevokeIn,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/customer-access/revoke',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Feature Flags
     * @returns FeatureFlagAdminOut Successful Response
     * @throws ApiError
     */
    public static listFeatureFlagsAdminFeatureFlagsGet(): CancelablePromise<Array<FeatureFlagAdminOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/feature-flags',
        });
    }
    /**
     * Update Feature Flag
     * @returns FeatureFlagAdminOut Successful Response
     * @throws ApiError
     */
    public static updateFeatureFlagAdminFeatureFlagsKeyPut({
        key,
        requestBody,
    }: {
        key: string,
        requestBody: FeatureFlagUpdateIn,
    }): CancelablePromise<FeatureFlagAdminOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/feature-flags/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Producer Principals
     * @returns ProducerPrincipalOut Successful Response
     * @throws ApiError
     */
    public static listProducerPrincipalsAdminProducerPrincipalsGet({
        projectId,
        limit = 100,
        offset,
    }: {
        projectId?: (number | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<Array<ProducerPrincipalOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/producer-principals',
            query: {
                'project_id': projectId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Producer Principal
     * @returns ProducerCredentialSecretOut Successful Response
     * @throws ApiError
     */
    public static createProducerPrincipalAdminProducerPrincipalsPost({
        requestBody,
    }: {
        requestBody: ProducerPrincipalCreate,
    }): CancelablePromise<ProducerCredentialSecretOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/producer-principals',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Disable Producer Principal
     * @returns void
     * @throws ApiError
     */
    public static disableProducerPrincipalAdminProducerPrincipalsPrincipalIdDelete({
        principalId,
    }: {
        principalId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/producer-principals/{principal_id}',
            path: {
                'principal_id': principalId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Rotate Producer Credential
     * @returns ProducerCredentialSecretOut Successful Response
     * @throws ApiError
     */
    public static rotateProducerCredentialAdminProducerPrincipalsPrincipalIdCredentialsPost({
        principalId,
        requestBody,
    }: {
        principalId: string,
        requestBody: ProducerCredentialCreate,
    }): CancelablePromise<ProducerCredentialSecretOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/producer-principals/{principal_id}/credentials',
            path: {
                'principal_id': principalId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke Producer Credential
     * @returns void
     * @throws ApiError
     */
    public static revokeProducerCredentialAdminProducerPrincipalsPrincipalIdCredentialsCredentialIdDelete({
        principalId,
        credentialId,
    }: {
        principalId: string,
        credentialId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/producer-principals/{principal_id}/credentials/{credential_id}',
            path: {
                'principal_id': principalId,
                'credential_id': credentialId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Admin Scope Definition
     * @returns ScopeDefinitionOut Successful Response
     * @throws ApiError
     */
    public static getAdminScopeDefinitionAdminProjectsProjectIdScopeDefinitionGet({
        projectId,
    }: {
        projectId: number,
    }): CancelablePromise<ScopeDefinitionOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/projects/{project_id}/scope-definition',
            path: {
                'project_id': projectId,
            },
            errors: {
                401: `Authentication is required.`,
                403: `The caller is not authorized for this project.`,
                404: `The project or scope was not found.`,
                422: `The scope request is invalid.`,
            },
        });
    }
    /**
     * Put Admin Scope Definition
     * @returns ScopeDefinitionOut Successful Response
     * @throws ApiError
     */
    public static putAdminScopeDefinitionAdminProjectsProjectIdScopeDefinitionPut({
        projectId,
        requestBody,
    }: {
        projectId: number,
        requestBody: ScopeDefinitionIn,
    }): CancelablePromise<ScopeDefinitionOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/projects/{project_id}/scope-definition',
            path: {
                'project_id': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication is required.`,
                403: `The caller is not authorized for this project.`,
                404: `The project or scope was not found.`,
                409: `The scope definition is locked.`,
                422: `The scope request is invalid.`,
            },
        });
    }
}
